<!-- <button (click)="increment()">Increment</button>
 
<div>Current Count: {{ count$ | async }}</div>

<button (click)="decrement()">Decrement</button>

<button (click)="reset()">Reset Counter</button> -->
<!-- <link href="http://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<script src="https://code.jquery.com/jquery-2.1.1.min.js"></script>
  <script src="js/materialize.js"></script>
  <script src="js/init.js"></script> -->



<!-- <app-header></app-header>
  <main>
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer> -->

<app-edison-home [edisonCode]="edisonCode" *ngIf="edisonCode"></app-edison-home>

<div class="flex flex-col w-full h-screen" *ngIf="!edisonCode">
  <div class="flex-shrink-0">
    <app-header></app-header>
  </div>
  <div class="bg-[#2a3a6c] flex-1 min-h-0 overflow-y-auto">
    <router-outlet></router-outlet>
  </div>
  <div class="bg-gray-200 flex-shrink-0">
    <app-footer></app-footer>
  </div>
</div>
